import React, { Component, Fragment } from 'react';
import IntroContainer from '../../containers/IntroContainer';
import Footer from './../../containers/FooterContainer';

class Intro extends Component {
    render() {
        return (
            <IntroContainer {...this.props} />
        );
    }
}
export default Intro;


// WEBPACK FOOTER //
// /src/screens/Intro/index.js